// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switcher_switch__ldimA","slider":"Switcher_slider__21CyA","active":"Switcher_active__wzFL1","round":"Switcher_round__2z_5O"};